module.exports = __webpack_public_path__ + "static/media/imghands.1dd92ff3.png";